"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
var _d3Shape = require("d3-shape");
var _d3Scale = require("d3-scale");
var _d3Interpolate = require("d3-interpolate");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var GaugeChart = /*#__PURE__*/function (_Component) {
  _inherits(GaugeChart, _Component);
  var _super = _createSuper(GaugeChart);
  function GaugeChart() {
    var _this;
    _classCallCheck(this, GaugeChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderArcMeter", function (radiusLimit) {
      var _this$props = _this.props,
        numOfLevels = _this$props.numOfLevels,
        cornerRadius = _this$props.cornerRadius;
      var arcWidth = radiusLimit / 3;
      var innerRadius = arcWidth * 2;
      var outerRadius = innerRadius + arcWidth;
      var startAngle = -Math.PI / 2;
      var padding = Math.PI / 100;
      var arcLength = (Math.PI - (numOfLevels - 1) * padding) / numOfLevels;
      var arcMeters = _toConsumableArray(new Array(numOfLevels).keys()).map(function (i) {
        return (0, _d3Shape.arc)().cornerRadius(cornerRadius)({
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: startAngle + i * (arcLength + padding),
          endAngle: startAngle + i * (arcLength + padding) + arcLength
        });
      });
      var colorScale = (0, _d3Scale.scaleLinear)().domain([1, numOfLevels / 2, numOfLevels]).interpolate(_d3Interpolate.interpolateHsl).range(["#ffa39e", "#ffe58f", "#b7eb8f"]); // same as antd alert bg colors
      var colors = _toConsumableArray(new Array(numOfLevels).keys()).map(function (i) {
        return colorScale(i + 1);
      });
      return arcMeters.map(function (arcMeter, i) {
        return /*#__PURE__*/_react.default.createElement("path", {
          d: arcMeter,
          fill: colors[i],
          key: i
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderNeedle", function (radiusLimit) {
      var _this$props2 = _this.props,
        value = _this$props2.value,
        domain = _this$props2.domain;
      var color = "#aaa";
      var r = radiusLimit / 12;
      var angleCalc = (0, _d3Scale.scaleLinear)().domain(domain).range([-90, 90]);
      return /*#__PURE__*/_react.default.createElement("g", {
        transform: "rotate(".concat(angleCalc(value), ")")
      }, /*#__PURE__*/_react.default.createElement("polygon", {
        points: "-".concat(r, ",0 0,-").concat(r * 10, ", ").concat(r, ",0"),
        fill: color
      }), /*#__PURE__*/_react.default.createElement("circle", {
        r: r,
        fill: color
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderText", function (radiusLimit) {
      var _this$props3 = _this.props,
        textFormatter = _this$props3.textFormatter,
        textStyle = _this$props3.textStyle,
        value = _this$props3.value;
      return /*#__PURE__*/_react.default.createElement("text", {
        y: -radiusLimit / 3,
        style: textStyle
      }, textFormatter(value));
    });
    return _this;
  }
  _createClass(GaugeChart, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        width = _this$props4.width,
        height = _this$props4.height,
        margin = _this$props4.margin;
      var xDelta = (width - margin.left - margin.right) / 2 + margin.left;
      var yDelta = height - margin.bottom;
      var radiusLimit = Math.max(Math.min(height - margin.top - margin.bottom, (width - margin.left - margin.right) / 2), 0); // avoid non-negative value
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(xDelta, ",").concat(yDelta, ")")
      }, this.renderArcMeter(radiusLimit), this.renderNeedle(radiusLimit), this.renderText(radiusLimit)));
    }
  }]);
  return GaugeChart;
}(_react.Component);
_defineProperty(GaugeChart, "propTypes", {
  domain: _propTypes.default.arrayOf(_propTypes.default.number),
  value: _propTypes.default.number.isRequired,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  numOfLevels: _propTypes.default.number,
  cornerRadius: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin,
  textFormatter: _propTypes.default.func,
  textStyle: _propTypes.default.object
});
_defineProperty(GaugeChart, "defaultProps", {
  domain: [0, 100],
  width: 700,
  height: 400,
  numOfLevels: 5,
  cornerRadius: 6,
  margin: {
    left: 50,
    right: 50,
    top: 50,
    bottom: 50
  },
  textFormatter: function textFormatter(val) {
    return "".concat(val, "%");
  },
  textStyle: {
    fontSize: "3em",
    textAnchor: "middle"
  }
});
var _default = GaugeChart;
exports.default = _default;